export default __webpack_public_path__ + "static/media/view-and-share.88e17650.svg";